const fallbackApiUrl =
  import.meta.env.VITE_API_URL ||
  import.meta.env.VITE_BACKEND_URL ||
  'http://localhost:8000';

export const getApiBaseUrl = () => {
  return window.__TENANT_RUNTIME__?.apiBaseUrl || fallbackApiUrl;
};

export const config = {
  get API_URL() {
    return getApiBaseUrl();
  },
};

export const admin_apiConfig = {
  get baseURL() {
    return getApiBaseUrl();
  },
  endpoints: {
    agentChatStream: '/api/conversations/stream',
    agentSessionTimeline: '/api/conversations',
    agentSessionGraphSnapshot: '/api/conversations',
    agentSessionViewAuthoringPreview: '/api/conversations',
    agentSessionContextUsage: '/api/conversations',
    ontologySyncPreview: '/api/sync_data/preview',
    ontologySyncRun: '/api/sync_data/run',
  },
};
